import { BaseResponseSchema } from '@monetize/types/common';
import { z } from 'zod';
import { OpportunityStatusEnumZ } from './enums.types';
import { OpportunityQuoteRespSchema } from './quote.types';

// from GET /api/opportunities
export const OpportunitySummaryRespSchema = z.object({
  id: z.string(),
  name: z.string(),
  customId: z.string().nullish(),
  primaryQuote: z.object({ id: z.string(), name: z.string() }).nullish(),
  createdBy: z.string(),
  createDate: z.string(),
  lastModifiedBy: z.string(),
  modifyDate: z.string(),
  amount: z.number(),
  currency: z.string(),
  dealRoomId: z.string().nullish(),
  accountId: z.string().nullish(),
  accountName: z.string().nullish(),
});
export type IOpportunitySummary = z.infer<typeof OpportunitySummaryRespSchema>;

// GET api/opportunities/{id}
export const OpportunityWithQuotesRespSchema = BaseResponseSchema.extend({
  id: z.string(),
  accountId: z.string(),
  accountName: z.string(),
  customId: z.string(),
  status: OpportunityStatusEnumZ,
  amount: z.number(),
  name: z.string(),
  primaryQuoteId: z.string(),
  owner: z.string(), // userId
  quotes: OpportunityQuoteRespSchema.array().nullish(),
  currency: z.string(),
  dealRoomId: z.string().nullish(),
});
export type IOpportunityWithQuotes = z.infer<
  typeof OpportunityWithQuotesRespSchema
>;

// GET api/opportunities/{id}
export const OpportunityReqSchema = z.object({
  name: z.string().nullish(),
  customId: z.string().nullish(),
  accountId: z.string(),
  primaryQuoteId: z.string().nullish(),
});
export type IOpportunityReqSchema = z.infer<typeof OpportunityReqSchema>;

export type CrmOpportunityForInput = { id: string; name: string };
